export const U3204_CONVERSATION_GROUP_MAX_VISIBLE = 5;

export type U3204TruncatedGroupResult<T> = {
  visible: T[];
  hiddenCount: number;
  hasMore: boolean;
  totalCount: number;
};

/**
 * Limite le nombre d'éléments visibles dans un groupe sidebar (BL-0155).
 */
export function u3204TruncateConversationGroup<T>(
  items: T[],
  expanded: boolean,
  maxVisible = U3204_CONVERSATION_GROUP_MAX_VISIBLE,
): U3204TruncatedGroupResult<T> {
  const totalCount = items.length;
  if (expanded || totalCount <= maxVisible) {
    return {
      visible: items,
      hiddenCount: 0,
      hasMore: false,
      totalCount,
    };
  }

  return {
    visible: items.slice(0, maxVisible),
    hiddenCount: totalCount - maxVisible,
    hasMore: true,
    totalCount,
  };
}
